import { QueryClient } from '@tanstack/react-query';

/**
 * Shared React Query client — the single instance used across the app.
 *
 * Lives in its own module (not main.tsx) so that non-React modules such as
 * lib/api.ts can import it to invalidate cached queries after mutations
 * (cross-entity cache invalidation).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
